import { COMPONENT_NAME_PREFIX } from '../constants';
var elementName = COMPONENT_NAME_PREFIX + "page-state";
export var PAGE_STATE_CONSTANTS = {
    elementName: elementName
};
